import React from 'react'
import { motion, useReducedMotion, Variants } from 'framer-motion'

interface RevealProps {
  children: React.ReactNode
  className?: string
  delay?: number
  y?: number
  duration?: number
  once?: boolean
  amount?: number
}

const Reveal: React.FC<RevealProps> = ({
  children,
  className = '',
  delay = 0,
  y = 32,
  duration = 0.9,
  once = true,
  amount = 0.25,
}) => {
  const prefersReduced = useReducedMotion()

  const variants: Variants = {
    hidden: { opacity: 0, y: prefersReduced ? 0 : y, filter: 'blur(8px)' },
    visible: {
      opacity: 1,
      y: 0,
      filter: 'blur(0px)',
      transition: {
        duration,
        delay,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  }

  return (
    <motion.div
      className={className}
      variants={variants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once, amount }}
    >
      {children}
    </motion.div>
  )
}

export default Reveal
